export default {
  configure() {},
  setApplicationIconBadgeNumber() {}
};
